// What the server says the signed in person may do, for the Engine screens that depend on it.
// The menu and the shell keep reading the mapped role; screens that need approvals or codes read this.
import { useAuth } from './useAuth'

export function useAccess() {
  const { meState, meError, access, accessClient, setWorkspaceId, retryMe } = useAuth()
  return { meState, meError, access, client: accessClient, setWorkspaceId, retry: retryMe }
}
